import { adminApi } from '@/services/api';

export interface ExportOption {
  key: string;
  label: string;
  exportFn: (fromDate?: string, toDate?: string) => Promise<{ data: Blob }>;
  filename: string;
}

// Pre-configured export options for common use cases
export const exportOptions = {
  purchases: {
    key: 'purchases',
    label: 'Purchases',
    exportFn: adminApi.exportPurchases,
    filename: 'purchases',
  },
  revenue: {
    key: 'revenue',
    label: 'Revenue (Real Money)',
    exportFn: adminApi.exportRevenue,
    filename: 'revenue',
  },
  inGameCurrencyBurn: {
    key: 'in-game-currency-burn',
    label: 'Revenue (In-Game Currency)',
    exportFn: adminApi.exportInGameCurrencyBurn,
    filename: 'in_game_currency_burn',
  },
  riskAnalytics: {
    key: 'risk-analytics',
    label: 'Risk Analytics (Hack Heuristics)',
    exportFn: adminApi.exportRiskAnalytics,
    filename: 'risk_analytics',
  },
  ftueBugCohort: {
    key: 'cohort-ftue-bug',
    label: 'FTUE Bug Cohort',
    exportFn: () => adminApi.exportFtueBugCohort(),
    filename: 'ftue_bug_cohort',
  },
  partialSquadCohort: {
    key: 'cohort-partial-squad',
    label: 'Partial-Squad Buckets',
    exportFn: () => adminApi.exportPartialSquadCohort(),
    filename: 'partial_squad_cohort',
  },
  players: {
    key: 'players',
    label: 'Players',
    exportFn: adminApi.exportPlayers,
    filename: 'players',
  },
  dau: {
    key: 'dau',
    label: 'Daily Active Users',
    exportFn: adminApi.exportDAU,
    filename: 'dau',
  },
  auditLogs: {
    key: 'audit-logs',
    label: 'Audit Logs',
    exportFn: adminApi.exportAuditLogs,
    filename: 'audit_logs',
  },
  economyPerDivision: {
    key: 'economy-per-division',
    label: 'Economy Per Division',
    exportFn: adminApi.exportEconomyPerDivision,
    filename: 'economy_per_division',
  },
  globalAiAnalytics: {
    key: 'ai-analytics',
    label: 'AI Analytics (All Players)',
    exportFn: adminApi.exportGlobalAiAnalytics,
    filename: 'ai_analytics_global',
  },
  // §3.1 — Match analytics (by-type / custom overs / per-day)
  matchBreakdown: {
    key: 'match-breakdown',
    label: 'Match Analytics (by type + custom overs)',
    exportFn: adminApi.exportMatchBreakdown,
    filename: 'match_breakdown',
  },
  // §3.2 — Retention funnel snapshot
  retentionFunnel: {
    key: 'retention-funnel',
    label: 'Retention Funnel (DAU/WAU/MAU + at-risk + churned)',
    exportFn: () => adminApi.exportRetentionFunnel(),
    filename: 'retention_funnel',
  },
  // §3.3 — Funnel drop-off
  funnelDropOff: {
    key: 'funnel-drop-off',
    label: 'Funnel Drop-off (zero-match users)',
    exportFn: () => adminApi.exportFunnelDropOff(),
    filename: 'funnel_drop_off',
  },
  // §6.5 — Suspect matches (cheat detection)
  suspectMatches: {
    key: 'suspect-matches',
    label: 'Suspect Matches (cheat-detection flagged)',
    exportFn: adminApi.exportSuspectMatches,
    filename: 'suspect_matches',
  },
  // AI Batting Diagnostics — per-wicket flat CSV.
  aiWicketDiagnostics: {
    key: 'ai-wicket-diagnostics',
    label: 'AI Wicket Diagnostics (per-wicket events)',
    exportFn: adminApi.exportAiWicketDiagnostics,
    filename: 'ai_wicket_diagnostics',
  },
};
